<template functional>
  <div class="text-area-wrapper">
    <div
      class="input__wrapper-custom"
      :class="[
      data.class,
      data.staticClass,
      'sf-textarea',
      {
        'sf-textarea--has-text': !!props.value,
        'sf-textarea--invalid': !props.valid,
      },
    ]"
      :style="[data.style, data.staticStyle]"
      v-bind="data.attrs"
    >
      <label
        v-if="props.label"
        :class="{ 'display-none': !props.label ,'required': props.required !== false } "
        class="label will-change"
        :for="props.name"
      >
        {{ props.label }}
        <span
          class="cursor-pointer"
          :class="{ 'tooltip': props.tooltip}"
          @mouseover="$emit('toggle-tooltip', true)"
          @mouseleave="$emit('toggle-tooltip', false)"
        >
          </span>
        <span v-if="!props.required" class="optional"> {{ $t('optional') }} </span>
      </label>
      <textarea
        width="100%"
        height="100%"
        :id="props.name"
        :value="props.value"
        :name="props.name"
        :placeholder="props.placeholder"
        :cols="props.cols"
        :rows="props.rows"
        :wrap="props.wrap"
        :disabled="props.disabled"
        :required="props.required"
        :maxlength="props.maxlength"
        :minlength="props.minlength"
        :readonly="props.readonly"
        v-on="$options.handleInput(listeners)"
      />
    </div>
    <div class="sf-textarea__error-message sf-input__error-message error">
      <transition name="sf-fade">
        <slot name="error-message" v-bind="{ props }">
          <div :class="{ 'display-none': props.valid }">
            {{ props.errorMessage }}
          </div>
        </slot>
      </transition>
    </div>
  </div>
</template>
<script>
import {focus} from "~/node_modules/@storefront-ui/vue/src/utilities/directives";

export default {
  name: "Textarea",
  directives: {
    focus,
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    cols: {
      type: [String, Number],
      default: "20",
    },
    rows: {
      type: [String, Number],
      default: "",
    },
    maxlength: {
      type: [String, Number],
      default: null,
    },
    minlength: {
      type: [String, Number],
      default: null,
    },
    wrap: {
      type: String,
      default: "soft",
      validator: (value) => {
        return ["soft", "hard", "off"].includes(value);
      },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
      description: "Native textarea required attribute",
    },
    placeholder: {
      type: String,
      default: "",
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      description: "Native input disabled attribute",
    },
  },
  handleInput(listeners) {
    return {
      ...listeners,
      input: ($event) =>
        listeners.input && listeners.input($event.target.value),
    };
  },
};
</script>
